// import { createRoot } from "react-dom/client";

// import ContactUsOne from "./ContactUsOne.component";

// export default function View() {
//     return(
//         <ContactUsOne />
//     );
// }
// const root = createRoot(document.getElementById("rootContactUs"));
// root.render(<View />);